import styled, { css } from 'styled-components';

import { Icon, Link } from '@powdr/components';
import { DatePicker } from '@powdr/components/widgets/datepicker';
import { Select } from '@powdr/components/widgets/select';
import {
  ThemeProps as Prop, Breakpoints, Components, FontFamily,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

const CPNT = Components.BOOKING_WIDGET;

export const StyledBookingWidget = styled.div`
  ${({ $isInSidebarDrawer }) => $isInSidebarDrawer && `
    margin: 15px 0;
  `}
`;

export const StyledTabField = styled.div`
  color: #55595c;
  position: relative;
  text-align: left;
  display: inline-block;
  margin-bottom: 15px;
  margin-right: 15px;
  width: 200px;
  min-height: 47.5px;

  ${Breakpoints.mobile(css`
    display: block;
    width: 100%;
  `)}

  &.w-300 {
    width: 300px;
  }
`;

export const StyledMobileIcon = styled(Icon)``;

const baseButtonStyles = css`
  color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_INACTIVE, CPNT, $colorProfile)};
  border: 1px solid ${({ $colorProfile }) => themeUtil(Prop.BORDER, CPNT, $colorProfile)};
  ${() => getFontStyles(FontFamily.SECONDARY_FONT)};
  cursor: pointer;
  position: relative;
  text-align: center;
  // line-height: normal;
  width: auto;
  height: auto;
  padding: 16px 20px;
  margin: 0 0 15px 0;
  max-height: 500px;

  &:hover:not(.disabled) {
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, $colorProfile)};

    svg {
      fill: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, $colorProfile)};
      color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, $colorProfile)};
    }
  }

  &:focus, &.active {
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_ACTIVE, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_ACTIVE, CPNT, $colorProfile)};
  }

  &:not(.active) {
    .mobile-icon {
      transition: .5s transform ease-in-out;
      transform: rotate(-90deg);
    }
  }

  .mobile-icon {
    transition: .5s transform ease-in-out;
  }

  &.disabled {
    cursor: not-allowed;
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_INACTIVE, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_INACTIVE, CPNT, $colorProfile)};
  }
`;

export const TabExecuteButton = styled(Link)`
  ${baseButtonStyles}
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  height: 52px;
  width: 100%;
  max-width: 275px;
  background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG, CPNT, $colorProfile)};
  border: none;
  color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, $colorProfile)};
  padding: 0;

  ${Breakpoints.mobile(css`
    max-width: unset;
    width: 60%;
  `)}
`;

export const MobileComponentWrapper = styled.div``;

export const StyledSelect = styled(Select)`
  //${({ is5050 }) => ((is5050) ? 'width: 100%; max-width: none; margin-bottom: 10px;' : '')}
  margin-right: 0;
  margin-bottom: 0;
  background-color: ${() => themeUtil(Prop.BACKGROUND, CPNT)};
  color: ${() => themeUtil(Prop.CONTENT, CPNT)};
  cursor: pointer;
  height: 52px;
  
  .react-select__control {
    height: 52px;
  }

  ${Breakpoints.mobile(css`
    max-width: unset;
  `)}
`;

export const StyledDatePicker = styled(DatePicker)`
  //${({ is5050 }) => ((is5050) ? 'width: 100%; max-width: none; margin-bottom: 10px;' : '')}
  margin-right: 0;
  margin-bottom: 0;
  background-color: ${() => themeUtil(Prop.BACKGROUND, CPNT)};
  color: ${() => themeUtil(Prop.CONTENT, CPNT)};
  height: 52px;

  ${Breakpoints.mobile(css`
    max-width: unset;
  `)}
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  max-width: 275px;

  ${Breakpoints.mobile(css`
    max-width: unset;
    width: 90%;
  `)}
`;

export const FieldLabel = styled.label`
  margin-bottom: 3px;
  color: ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)};
`;

export const WidgetFields = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 15px;

  ${({ $is5050, $isInSidebarDrawer }) => (($is5050 || $isInSidebarDrawer) ? 'align-items: center; flex-direction: column;' : 'align-items: flex-end;')};

  ${Breakpoints.mobile(css`
    flex-direction: column;
    align-items: center;
  `)}
`;
